import { useEffect } from "react";
import { Link } from "react-router-dom";
import { BUSINESS } from "../data/regions";
import { ArrowLeft } from "lucide-react";

const MentionsLegales = () => {
  useEffect(() => {
    document.title = "Mentions Légales | BKR Toiture - Artisan Couvreur";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "Mentions légales du site BKR Toiture, artisan couvreur dans les Yvelines (78) et en Haute-Savoie (74).");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="mentions-legales-page">
      {/* Header */}
      <div className="bg-[#0F172A] text-white py-20 pt-28">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight font-['Barlow_Condensed']" data-testid="mentions-legales-title">
            Mentions Légales
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-12">
        <div className="bg-white p-8 md:p-12 shadow-sm space-y-8 text-[#334155] leading-relaxed">

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              1. Éditeur du site
            </h2>
            <p>Le site <strong>kbrtoiture.fr</strong> est édité par :</p>
            <ul className="mt-3 space-y-1 list-none">
              <li><strong>Raison sociale :</strong> [Nom de la société]</li>
              <li><strong>Forme juridique :</strong> [Forme juridique - ex: Auto-entrepreneur / SARL / SAS]</li>
              <li><strong>SIRET :</strong> [SIRET]</li>
              <li><strong>Responsable de la publication :</strong> [Nom du responsable]</li>
              <li><strong>Adresse du siège :</strong> [Adresse complète]</li>
              <li><strong>Téléphone :</strong> {BUSINESS.phone}</li>
              <li><strong>Email :</strong> {BUSINESS.email}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              2. Hébergement
            </h2>
            <p>Le site est hébergé par :</p>
            <ul className="mt-3 space-y-1 list-none">
              <li><strong>Hébergeur :</strong> [Nom de l'hébergeur]</li>
              <li><strong>Adresse :</strong> [Adresse de l'hébergeur]</li>
              <li><strong>Téléphone :</strong> [Téléphone de l'hébergeur]</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              3. Activité
            </h2>
            <p>
              BKR Toiture est une entreprise spécialisée dans les travaux de couverture, charpente, ravalement de façade 
              et isolation. Nous intervenons dans les Yvelines (78), en Île-de-France, ainsi qu'en Haute-Savoie (74) 
              et dans la région de Genève.
            </p>
            <p className="mt-2">
              <strong>Garantie décennale :</strong> L'entreprise dispose d'une assurance décennale couvrant l'ensemble 
              de ses travaux, conformément aux articles 1792 et suivants du Code civil.
            </p>
            <ul className="mt-3 space-y-1 list-none">
              <li><strong>Assureur :</strong> [Nom de l'assureur]</li>
              <li><strong>N° de police :</strong> [Numéro de police d'assurance]</li>
              <li><strong>Zone de couverture :</strong> France métropolitaine</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              4. Propriété intellectuelle
            </h2>
            <p>
              L'ensemble des éléments constituant le site (textes, images, graphismes, logos, icônes, sons, logiciels, etc.) 
              est la propriété exclusive de [Nom de la société] ou de ses partenaires. Toute reproduction, représentation, 
              modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le 
              procédé utilisé, est interdite, sauf autorisation écrite préalable de [Nom de la société].
            </p>
            <p className="mt-2">
              Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée 
              comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et 
              suivants du Code de la Propriété Intellectuelle.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              5. Données personnelles
            </h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, 
              vous disposez de droits sur vos données personnelles. Pour en savoir plus, consultez notre{" "}
              <Link to="/politique-de-confidentialite" className="text-[#C2410C] hover:underline font-medium">
                Politique de Confidentialité
              </Link>.
            </p>
            <p className="mt-2">
              Pour toute question relative à la protection de vos données personnelles, vous pouvez nous contacter à 
              l'adresse : <a href={`mailto:${BUSINESS.email}`} className="text-[#C2410C] hover:underline font-medium">{BUSINESS.email}</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              6. Cookies
            </h2>
            <p>
              Le site utilise des cookies pour améliorer l'expérience de navigation et mesurer l'audience. 
              Un bandeau de consentement vous est présenté lors de votre première visite. Vous pouvez à tout moment 
              modifier vos préférences en matière de cookies.
            </p>
            <p className="mt-2">
              Pour en savoir plus sur l'utilisation des cookies, consultez notre{" "}
              <Link to="/politique-de-confidentialite" className="text-[#C2410C] hover:underline font-medium">
                Politique de Confidentialité
              </Link>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              7. Limitation de responsabilité
            </h2>
            <p>
              [Nom de la société] s'efforce de fournir sur le site des informations aussi précises que possible. 
              Toutefois, elle ne pourra être tenue responsable des oublis, des inexactitudes et des carences dans la 
              mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.
            </p>
            <p className="mt-2">
              Toutes les informations indiquées sur le site sont données à titre indicatif et sont susceptibles 
              d'évoluer. Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs. 
              Ils sont donnés sous réserve de modifications ayant été apportées depuis leur mise en ligne.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              8. Liens hypertextes
            </h2>
            <p>
              Le site peut contenir des liens hypertextes vers d'autres sites. Cependant, [Nom de la société] 
              n'a pas la possibilité de vérifier le contenu des sites ainsi visités, et n'assumera en conséquence 
              aucune responsabilité de ce fait.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] uppercase tracking-tight font-['Barlow_Condensed'] mb-4">
              9. Droit applicable
            </h2>
            <p>
              Tout litige en relation avec l'utilisation du site est soumis au droit français. 
              En cas de litige, la compétence est attribuée aux tribunaux compétents de [Ville du tribunal compétent].
            </p>
          </section>

          <div className="pt-6 border-t border-[#E2E8F0] text-sm text-[#94A3B8]">
            <p>Dernière mise à jour : Janvier 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
